import React, { useMemo } from "react";
import { useMetadata } from "hooks/query";
import { useSection } from "hooks/section";

const UseRegularBanner = () => {
    const metadataQuery = useMetadata();
    let { sectionUrl } = useSection();

    return useMemo(() => {
        let matches =
            metadataQuery.isSuccess &&
            metadataQuery.data.banners.$values.filter(
                (value) =>
                ( value.position === "Sectionwide" &&
                  value.identifier === (sectionUrl) || value.position ==="Sitewide") &&
                  value.size === "Regular"
            );            
    
        return matches;
    }, [metadataQuery, sectionUrl]);
};


export default UseRegularBanner;
